module.exports = __webpack_public_path__ + "static/Retiro_Inicio_Brecha-a6c1b81a11faaea91bbd687a276b95e1.jpg";